<template>
  <v-dialog v-model="visible" width="60vw" max-width="90vw" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">シミュレーションリンク</span>
      </v-card-title>
      <v-card-text>
        <div>{{ simulationPlanUrl }}</div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <div v-show="isCopyComplete">クリップボードにコピーしました</div>
        <v-spacer />
        <v-btn @click="copyClick()" color="primary">URLコピー</v-btn>
        <AppButtonCancel @click="close">閉じる</AppButtonCancel>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { SimulationPlanRepository } from '@/models/Simulation'
import { mapActions } from 'vuex'
import { snackbarType } from '@/vuex/modules/ui/snackbar/constants'

export default {
  name: 'SimulationUrlLinkModal',
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    simulationId: {
      type: Number,
      default: null,
    },
    hashId: {
      type: String,
      default: null,
    },
    agencyId: {
      type: Number,
      default: null,
    },
    advertiserId: {
      type: Number,
      default: null,
    },
    isLoginLP: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      isCopyComplete: false,
      simulationPlanUrl: '',
    }
  },
  async created() {
    try {
      this.simulationPlanUrl = await this.getSimulationPlanUrl()
    } catch (e) {
      this.showSnackbar({
        type: snackbarType.ERROR,
        message: 'URLの取得に失敗しました',
      })
    }
  },
  methods: {
    ...mapActions('snackbar', {
      showSnackbar: 'SHOW_SNACKBAR',
    }),
    async getHashId() {
      if (this.hashId) {
        return this.hashId
      }
      return SimulationPlanRepository.makeHashId(this.simulationId)
    },
    async getSimulationPlanUrl() {
      const host = location.protocol + '//' + location.host
      const endpoint = '/simulations/readonly'
      const hashId = await this.getHashId()
      const query = '?hashId=' + hashId
      return host + endpoint + query
    },
    async copyClick() {
      try {
        await navigator.clipboard.writeText(this.simulationPlanUrl)
        this.isCopyComplete = true
      } catch (e) {
        console.log(e)
      }
    },
    close() {
      this.$emit('cancel')
    },
  },
}
</script>

<style></style>
